import React from "react";
import "../Orders/Orders.css";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function createData1(productName, requested, unit, subtotal, stock, final) {
  return {
    productName,
    requested,
    unit,
    subtotal,
    stock,
    final,
  };
}

const rows1 = [
  createData1(
    "Exterior Paint 20L",
    "10",
    "₹2,150",
    "₹21,500",
    "45",
 
  ),
 createData1(
    "Exterior Paint 20L",
    "10",
    "₹2,150",
    "₹21,500",
    "45",
 
  ),
 createData1(
    "Exterior Paint 20L",
    "10",
    "₹2,150",
    "₹21,500",
    "45",
 
  ),
];

export const ManageSubDistributors = () => {
  return (
    <div className="ordersContainer">
      <div className="container">
        <div className="d-flex gap-1 mb-2">
          <span className="me-2">
            <Link to="/state-view-subDistributors" style={{ color: "black" }}>
              <FaArrowLeftLong />
            </Link>
          </span>
          <div className="inventoryTitle">#ORD-2054</div>
        </div>
        <div className="inventorySubtitle">
          Review and process this sub-distributor order
        </div>
        {/* cards section  */}
        <div className="manageCardsGrid">
          <div className="manageCard">
            <div>Sub-distributor</div>
            <div>Sri Balaji Paints</div>
          </div>
          <div className="manageCard">
            <div>Order Date</div>
            <div>08-Sep-2025</div>
          </div>
          <div className="manageCard">
            <div>Payment Type</div>
            <div>Credit</div>
          </div>
          <div className="manageCard">
            <div>Order Amount</div>
            <div>₹47,643</div>
          </div>
          <div className="manageCard">
            <div>Amount Paid</div>
            <div>₹0</div>
          </div>
          <div className="manageCard">
            <div>Due Amount</div>
            <div>₹47,643</div>
          </div>
        </div>
        {/* wave and due  */}
        <div className="manageInputContainer">
          <div className="manageInput">
            <label>Wave Bill</label>
            <div>
              <input type="file" />
            </div>
          </div>
          <div className="manageInput">
            <label>Due Date</label>
            <div>
              {" "}
              <input type="date" className="py-2" />
            </div>
          </div>
        </div>
        {/* table  */}
        <div className="titleOrderList">Ordered Products</div>

        <div className="dashboardTableContainer">
          <TableContainer component={Paper}>
            <Table
              // sx={{ minWidth: 650 }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead className="dashboadTableHeader">
                <TableRow>
                  <TableCell>Product Name</TableCell>
                  <TableCell align="left">Requested Qty</TableCell>
                  <TableCell align="left">Unit Price (₹)</TableCell>
                  <TableCell align="left">Subtotal (₹)</TableCell>

                  <TableCell align="left">Stock Available</TableCell>
                  <TableCell align="left">Final Qty to Dispatch</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows1.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    className="dashboardTableBody"
                  >
                    <TableCell component="th" scope="row">
                      {row.productName}
                    </TableCell>
                    <TableCell align="left">{row.requested}</TableCell>
                    <TableCell align="left">{row.unit}</TableCell>
                    <TableCell align="left">{row.subtotal}</TableCell>
                    <TableCell align="left">{row.stock}</TableCell>
                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input type="text" value={row.final} />
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

           {/* Buttons */}
        <div className="d-flex justify-content-end">
             <div className="addModalButtons" style={{ marginTop: "20px",display:'flex',gap:'20px'}}>
          <button className="addBtnCancel">Cancel</button>
          <button className="addBtnSave">Generate Invoice</button>
        </div>

        </div>
      </div>
    </div>
  );
};
